<div class="widget-container">
    <div class="header">
        <div class="d-flex flex-column">
            <span class="header-title" *ngIf="contract?.HasE && contract?.HasG">
                {{ "pt.edp.edponline.smartnow.nextBilling.allSentTitle" | translate }}
            </span>
            <span class="header-title" *ngIf="contract?.HasE && !contract?.HasG">
                {{ "pt.edp.edponline.smartnow.nextBilling.electricitySent" | translate }}
            </span>
            <span class="header-title" *ngIf="!contract?.HasE && contract?.HasG">
                {{ "pt.edp.edponline.smartnow.nextBilling.gasSent" | translate }}
            </span>
            <span class="header-description">
                {{ "pt.edp.edponline.smartnow.nextBilling.from" | translate }}
                <b>{{ (contract?.SmartNow?.Simulation?.Start | date: "dd MMM").replace(".", "") }}</b>
                {{ "pt.edp.edponline.smartnow.nextBilling.to" | translate }}
                <b>{{ (contract?.SmartNow?.Simulation?.End | date: "dd MMM").replace(".", "") }}</b>
            </span>
        </div>
        <i class="icon-edponline-Bop-023"></i>
    </div>

    <div class="body" *ngIf="contract?.HasE && !contract?.HasG && contract?.SmartNow">
        <div class="body-container">
            <div class="body-wrapper">
                <div class="body-value" [ngClass]="{ 'smaller-size': contract?.SmartNow?.Simulation?.ConsumptionE?.length > 4 }">
                    {{ contract?.SmartNow?.Simulation?.ConsumptionE | edpDotToComma }}
                    <span class="body-unit">{{ "pt.edp.edponline.smartnow.electricityUnit" | translate }}</span>
                </div>
            </div>
            <i class="icon-edponline-Bra-001 d-none d-lg-block"></i>
            <i class="icon-edponline-Bop-001 d-block d-lg-none"></i>
        </div>
        <div class="body-prediction">
            <div class="body-prediction-wrapper body-prediction-spacer">
                <span class="body-prediction-subtitle">
                    {{ "pt.edp.edponline.smartnow.nextBilling.prediction" | translate }}
                </span>
                <span class="body-prediction-cost">{{ contract?.SmartNow?.Simulation?.ValueE || "-" | edpDotToComma }} &euro;</span>
                <span class="body-prediction-tax d-none d-lg-block">{{ "pt.edp.edponline.smartnow.nextBilling.taxInfo" | translate }}</span>
            </div>
            <div class="flex-column d-none d-lg-flex">
                <span class="body-prediction-days">
                    {{ contract?.SmartNow?.Simulation?.Days }}&nbsp;
                    {{ "pt.edp.edponline.smartnow.nextBilling.realDays" | translate }}
                </span>
                <span class="body-prediction-days-label">{{ "pt.edp.edponline.smartnow.nextBilling.idealPeriodLabel" | translate }}</span>
            </div>
        </div>
    </div>

    <div class="body" *ngIf="!contract?.HasE && contract?.HasG && contract?.SmartNow">
        <div class="body-container">
            <div class="body-wrapper">
                <div class="body-value" [ngClass]="{ 'smaller-size': contract?.SmartNow?.Simulation?.ConsumptionG?.length > 4 }">
                    {{ contract?.SmartNow?.Simulation?.ConsumptionG | edpDotToComma }}
                    <span class="body-unit" *ngIf="contract?.SmartNow?.Simulation?.ConsumptionG">
                        {{ "pt.edp.edponline.consumptions.unit.gas" | translate }}
                    </span>
                </div>
            </div>
            <i class="icon-edponline-Bra-009 d-none d-lg-block"></i>
            <i class="icon-edponline-Bop-009 d-block d-lg-none"></i>
        </div>
        <div class="body-prediction">
            <div class="body-prediction-wrapper body-prediction-spacer">
                <span class="body-prediction-subtitle">
                    {{ "pt.edp.edponline.smartnow.nextBilling.prediction" | translate }}
                </span>
                <span class="body-prediction-cost">{{ contract?.SmartNow?.Simulation?.ValueG || "-" | edpDotToComma }} &euro;</span>
                <span class="body-prediction-tax d-none d-lg-block">{{ "pt.edp.edponline.smartnow.nextBilling.taxInfo" | translate }}</span>
            </div>
            <div class="flex-column d-none d-lg-flex">
                <span class="body-prediction-days">
                    {{ contract?.SmartNow?.Simulation?.Days }}&nbsp;
                    {{ "pt.edp.edponline.smartnow.nextBilling.realDays" | translate }}
                </span>
                <span class="body-prediction-days-label">{{ "pt.edp.edponline.smartnow.nextBilling.idealPeriodLabel" | translate }}</span>
            </div>
        </div>
    </div>

    <div class="body body-dual" *ngIf="contract?.HasE && contract?.HasG">
        <div class="d-flex flex-column w-100 body-dual-spacer">
            <span class="body-dual-title">
                {{ "pt.edp.edponline.smartnow.nextBilling.electricity" | translate }}
            </span>
            <div class="body-dual-wrapper">
                <div class="d-flex justify-content-start align-items-end">
                    <i class="icon-edponline-Bop-001"></i>
                    <div class="body-dual-value" [ngClass]="{ 'smaller-size': contract?.SmartNow?.Simulation?.ConsumptionE?.length > 4 }">
                        {{ contract?.SmartNow?.Simulation?.ConsumptionE || "-" | edpDotToComma }}
                        <span class="body-dual-unit">{{ "pt.edp.edponline.smartnow.electricityUnit" | translate }}</span>
                    </div>
                </div>

                <div class="body-dual-prediction">
                    <span class="body-dual-subtitle">
                        {{ "pt.edp.edponline.smartnow.nextBilling.prediction" | translate }}
                    </span>
                    <span class="body-dual-cost">{{ contract?.SmartNow?.Simulation?.ValueE || "-" | edpDotToComma }} &euro;</span>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column w-100">
            <span class="body-dual-title">
                {{ "pt.edp.edponline.smartnow.nextBilling.gas" | translate }}
            </span>
            <div class="body-dual-wrapper">
                <div class="d-flex justify-content-start align-items-end">
                    <i class="icon-edponline-Bop-009"></i>
                    <div class="body-dual-value" [ngClass]="{ 'smaller-size': contract?.SmartNow?.Simulation?.ConsumptionE?.length > 4 }">
                        {{ contract?.SmartNow?.Simulation?.ConsumptionG || "-" | edpDotToComma }}
                        <span class="body-dual-unit" *ngIf="contract?.SmartNow?.Simulation?.ConsumptionG">
                            {{ "pt.edp.edponline.consumptions.unit.gas" | translate }}
                        </span>
                    </div>
                </div>
                <div class="body-dual-prediction">
                    <span class="body-dual-subtitle">
                        {{ "pt.edp.edponline.smartnow.nextBilling.prediction" | translate }}
                    </span>
                    <span class="body-dual-cost">{{ contract?.SmartNow?.Simulation?.ValueG || "-" | edpDotToComma }} &euro;</span>
                </div>
            </div>
        </div>
    </div>

    <div
        class="footer total-prediction"
        *ngIf="
            contract?.HasE && contract?.HasG && contract?.SmartNow?.Simulation?.ValueG && contract?.SmartNow?.Simulation?.ValueE
        "
    >
        <div>
            <span class="mr-1" [innerHTML]="'pt.edp.edponline.smartnow.nextBilling.bothPredictionSimulation' | translate"></span>
            <b>{{ contract?.SmartNow?.Simulation?.ValueTotal | edpDotToComma }}</b>
            &euro;.
        </div>
    </div>

    <div
        class="footer"
        *ngIf="
            contract?.HasE &&
            contract?.HasG &&
            !contract?.SmartNow?.Simulation?.ValueG &&
            contract?.SmartNow?.Simulation?.ValueE
        "
    >
        <span class="footer-label" [innerHTML]="'pt.edp.edponline.smartnow.nextBilling.sendGasMessage' | translate"></span>
    </div>

    <div
        class="footer"
        *ngIf="
            contract?.HasE &&
            contract?.HasG &&
            contract?.SmartNow?.Simulation?.ValueG &&
            !contract?.SmartNow?.Simulation?.ValueE
        "
    >
        <span class="footer-label" [innerHTML]="'pt.edp.edponline.smartnow.nextBilling.sendElectricityMessage' | translate"></span>
    </div>
</div>
